import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import OneItem from './components/OneItem'

const RootContainer = styled.div`
	display: flex;
	margin: -3rem;
	justify-content: center;
	flex-wrap: wrap;

	> * {
		width: 33.3%;
		padding: 3rem;
		max-width: 26rem;
		
		@media only screen and (max-width: 1000px) {
			width: 50%;
		}
		
		@media only screen and (max-width: 670px) {
			width: 100%;
		}
	}
`

const NewsList = ({className, items}) => <RootContainer className={className}>
	{items.map(one => <OneItem key={one.link} data={one}/>)}
</RootContainer>

NewsList.propTypes = {
	className: PropTypes.string,
	items: PropTypes.arrayOf(OneItem.propTypes.data),
}

NewsList.defaultProps = {
	className: '',
}

export default NewsList
